export default __webpack_public_path__ + "5d08674fab6895e8bcb866592289caa5.png";